import ProfileSelector from '../configurator/ProfileSelector';
import StylePicker from '../configurator/StylePicker';

/**
 * HeroSection — full-viewport first screen.
 *
 * The canvas behind it shows the two wedding bands in their opening pose.
 * The profile selector chips act as the primary CTA.
 */
export default function HeroSection() {
    return (
        <section
            className="relative flex h-screen items-end justify-center pb-24"
            aria-label="Hero"
        >
            <div className="text-center">
                <h1 className="font-serif text-5xl tracking-widest uppercase text-[var(--fg)] md:text-7xl">
                    Henrich&nbsp;&amp;&nbsp;Denzel
                </h1>
                <p className="mt-4 text-sm tracking-[0.3em] uppercase text-[var(--fg-muted)]">
                    Werte Made in Germany seit 1984
                </p>

                {/* Profile selection CTA */}
                <div className="mt-10 flex justify-center">
                    <ProfileSelector />
                </div>

                {/* Style submenu: Stein | Rille | Welle (+ gem sub-row) */}
                <div className="mt-4 flex justify-center">
                    <StylePicker />
                </div>

                {/* Subtle scroll hint */}
                <div className="mt-8 flex justify-center">
                    <span className="block h-10 w-px animate-bounce bg-[var(--fg-muted)] opacity-40" />
                </div>
            </div>
        </section>
    );
}
